import React, { useState } from 'react';
import SubmitButton from './SubmitButton';
import ProductDescription from './ProductDescription';
import Spinner from './Spinner';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const UpdateInventory = ({ stores, location }) => {
    const [barcode, setBarcode] = useState('');
    const [selectedStore, setSelectedStore] = useState('');
    const [productDescription, setProductDescription] = useState('');
    const [productBrand, setProductBrand] = useState('');
    const [productUnit, setProductUnit] = useState('');
    const [quantity, setQuantity] = useState('');
    const [loading, setLoading] = useState(false);
    const [isFlipped, setIsFlipped] = useState(false);

    // Check if location is locked
    const lockedLocations = ['trueliberty', 'shuwaikh', 'bahman'];
    const isLocked = lockedLocations.includes(location);

    const handleInputChange = (e) => {
        setBarcode(e.target.value);
    };

    const handleStoreChange = (e) => {
        setSelectedStore(e.target.value);
    };

    const handleSubmit = () => {
        if (!selectedStore) {
            alert('Please select a section.');
            return;
        }

        if (!barcode) {
            alert('Please enter a product barcode.');
            return;
        }

        setLoading(true);

        fetch(`${API_URL}/product/${barcode}`)
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data.error) {
                    alert(data.error);
                } else {
                    setProductDescription(data.description);
                    setProductBrand(data.brand);
                    setProductUnit(data.unit);
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching product:', error);
                alert('Failed to fetch product details.');
            });
    };

    return (
        <div
            className={`card-container ${isFlipped ? 'flipped' : ''}`}
            style={{
                display: 'flex',
                justifyContent: 'center',
                perspective: '1000px',
                maxWidth: '800px',
                margin: '20px auto',
                textAlign: 'center',
            }}
        >
            <div
                className="card"
                style={{
                    width: '80%',
                    position: 'relative',
                    transformStyle: 'preserve-3d',
                    transition: 'transform 0.8s',
                    transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
                    minHeight: '400px',
                }}
            >
                {/* Front Side */}
                <div
                    style={{
                        position: 'absolute',
                        backfaceVisibility: 'hidden',
                        width: '100%',
                        padding: '20px',
                        border: '2px solid #ddd',
                        borderRadius: '8px',
                        backgroundImage: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        opacity: isLocked ? 0.7 : 1,
                        overflow: 'hidden',
                    }}
                >
                    {/* Locked Banner Overlay */}
                    {isLocked && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%) rotate(-45deg)',
                                backgroundColor: 'rgba(255, 215, 0, 0.95)',
                                color: '#1e3c72',
                                padding: '15px 100px',
                                fontSize: '24px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.4)',
                                border: '3px solid #1e3c72',
                                zIndex: 10,
                                whiteSpace: 'nowrap',
                                letterSpacing: '2px',
                            }}
                        >
                            2026 INVENTORY COMPLETED
                        </div>
                    )}

                    <h2 style={{ color: '#fff', marginTop: 0 }}>Update Inventory</h2>
                    
                    <div style={{ marginBottom: '20px' }}>
                        <select
                            value={selectedStore}
                            onChange={handleStoreChange}
                            disabled={isLocked}
                            style={{
                                padding: '10px',
                                fontSize: '16px',
                                marginRight: '10px',
                                width: '200px',
                                border: '2px solid black',
                                borderRadius: '5px',
                                cursor: isLocked ? 'not-allowed' : 'pointer',
                                opacity: isLocked ? 0.6 : 1,
                            }}
                        >
                            <option value="" disabled>Select a Section</option>
                            {stores.map(store => (
                                <option key={store.value} value={store.value}>
                                    {store.label}
                                </option>
                            ))}
                        </select>
                        <input
                            type="text"
                            placeholder="Enter Barcode"
                            value={barcode}
                            onChange={handleInputChange}
                            disabled={isLocked}
                            inputMode="numeric"
                            style={{
                                padding: '10px',
                                fontSize: '16px',
                                width: '160px',
                                border: '2px solid black',
                                borderRadius: '5px',
                                marginRight: '10px',
                                cursor: isLocked ? 'not-allowed' : 'text',
                                opacity: isLocked ? 0.6 : 1,
                            }}
                        />
                        <SubmitButton onClick={handleSubmit} label="Confirm" disabled={isLocked}/>
                    </div>

                    {loading ? (
                        <Spinner />
                    ) : (
                        <ProductDescription
                            description={productDescription}
                            brand={productBrand}
                            unit={productUnit}
                            store={selectedStore}
                            barcode={barcode}
                            quantity={quantity}
                            setQuantity={setQuantity}
                            setBarcode={setBarcode}
                            setProductDescription={setProductDescription}
                            setProductBrand={setProductBrand}
                            setProductUnit={setProductUnit}
                            setIsFlipped={setIsFlipped}
                            apiUrl={API_URL}
                            location={location}
                            isLocked={isLocked}
                        />
                    )}
                </div>

                {/* Back Side */}
                <div
                    style={{
                        position: 'absolute',
                        backfaceVisibility: 'hidden',
                        transform: 'rotateY(180deg)',
                        width: '100%',
                        padding: '20px',
                        border: '2px solid #ddd',
                        borderRadius: '8px',
                        backgroundImage: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        color: '#fff',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '200px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <h1>Inventory Updated!</h1>
                </div>
            </div>
        </div>
    );
};

export default UpdateInventory;